import { render, staticRenderFns } from "./ModalShortcuts.vue?vue&type=template&id=988f828a&lang=pug&"
import script from "./ModalShortcuts.vue?vue&type=script&lang=js&"
export * from "./ModalShortcuts.vue?vue&type=script&lang=js&"
import style0 from "./ModalShortcuts.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports